export const MIN_DISTANCE_FOR_START_DRAG = 5;
